import moment from 'moment';

export const NumberUtil = {

    format: (number) => {
        try {
            if(isNaN(number)) return 0;
            
            return number.toLocaleString();
        } catch (error) {
            return number
        }
    },

}